export default __webpack_public_path__ + "static/media/COBRA.139a3110.pdf";